import { graphql, useSubscription } from 'react-relay/hooks'

const subscription = graphql`
  subscription ReportWatcherSubscription(
    $input: ReportSubscriptionInput!
    $resolutionSection: String
    $anomalies: [String]
  ) {
    reportUpdated(input: $input) {
      event
      report {
        status
        errors
        reviewStatus
        ...ReportsTableRow_report
        ...ReportResolution_report
        ...ReportResolutionTable_report
        company {
          ...Integrations_company
          ...IntegrationChoices_company
        }
      }
    }
  }
`

export default function ReportWatcher({ reportId, resolutionSection, resolutionAnomalyView }) {
  useSubscription({
    subscription,
    variables: {
      input: { reportId },
      resolutionSection,
      anomalies: resolutionAnomalyView === 'all' ? null : [resolutionAnomalyView],
    },
    onNext: (response, ...args) => {
      console.log('Updated report', response.reportUpdated?.report)
    },
  })

  // this component doesn't render anything
  return null
}
